import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleBolt } from "@instadeepai/fontawesome-pro-regular"

import { Badge, cn } from "@shared/ui"

import { USER_STATUS, type UserStatus } from "../../types"

interface StatusBadgeProps {
  status: UserStatus
  className?: string
}

const getStatusConfig = (status: UserStatus) => {
  switch (status) {
    case USER_STATUS.ACTIVE:
      return {
        icon: faCircleBolt,
        className: "text-green-500",
      }
    case USER_STATUS.INACTIVE:
      return {
        icon: faCircleBolt,
        className: "text-gray-400",
      }
    case USER_STATUS.PENDING:
      return {
        icon: faCircleBolt,
        className: "text-yellow-500",
      }
    case USER_STATUS.SUSPENDED:
      return {
        icon: faCircleBolt,
        className: "text-red-500",
      }
    default:
      return {
        icon: faCircleBolt,
        className: "text-gray-400",
      }
  }
}

export const StatusBadge = ({ status, className }: StatusBadgeProps) => {
  const config = getStatusConfig(status)

  return (
    <Badge
      variant="secondary"
      size="sm"
      className={cn(
        "flex items-center justify-center rounded-full border-0 p-0",
        className
      )}
    >
      <FontAwesomeIcon
        icon={config.icon}
        className={cn("text-md", config.className)}
      />
    </Badge>
  )
}
